export default {
  local: 'http://localhost:6005/api',
  development: 'https://apibetalogin.tron.com.br/api',
  production: 'https://apilogin.tron.com.br/api',
};
